import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { createhoteladmin } from "../store/slices/auth";
import {
  nameregex,
  mobileregex,
  emailregex,
  usernameregex,
} from "../helper/regex";

const AddHotelOwner = () => {
  const [fullName, setfullName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [username, setUsername] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };

    switch (name) {
      case "fullName":
        setfullName(value);
        validationErrors[name] =
          value.trim() === "" || !nameregex.test(value)
            ? "Please enter a valid name"
            : "";
        break;

      case "email":
        setEmail(value);
        validationErrors[name] =
          value.trim() === "" || !emailregex.test(value)
            ? "Please enter a valid email"
            : "";
        break;

      case "mobile":
        const sanitizedValue2 = value.replace(/\D/g, "").slice(0, 10);
        setMobile(sanitizedValue2);
        validationErrors[name] =
          sanitizedValue2 === "" || !mobileregex.test(sanitizedValue2)
            ? "Please enter valid value"
            : "";
        break;

      case "username":
        setUsername(value);
        validationErrors[name] =
          value.trim() === "" || !usernameregex.test(value)
            ? "Please enter only alphabets and number"
            : "";
        break;

      default:
        break;
    }

    setErrors(validationErrors);
  };

  const addAdmin = async (e) => {
    e.preventDefault();
    setIsDisabled(true);
    setTimeout(() => setIsDisabled(false), 3000);

    const validationErrors = {};

    // Validate name
    if (!fullName.trim()) {
      validationErrors.fullName = "Please enter name";
    } else if (!nameregex.test(fullName)) {
      validationErrors.fullName = "Name must be at least three characters";
    }

    if (!email.trim()) {
      validationErrors.email = "Please enter email";
    } else if (!emailregex.test(email)) {
      validationErrors.email = "Please enter a valid email";
    }

    if (!username.trim()) {
      validationErrors.username = "Please enter username";
    } else if (!usernameregex.test(username)) {
      validationErrors.username = "Please enter a valid username";
    }

    if (!mobile.trim()) {
      validationErrors.mobile = "Please enter mobile number";
    } else if (!mobileregex.test(mobile)) {
      validationErrors.mobile = "Please enter a valid mobile number";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    let password = mobile;
    const item = {
      fullName,
      status: 1,
      email,
      mobile,
      username,
      password,
      roleId: "hotelAdmin",
    };

    try {
      await dispatch(createhoteladmin(item)).unwrap();
      alert("Hotel admin created successfully!");
      navigate("/admin/hoteladmin");
    } catch (error) {
      alert(error);
    }
  };

  function cancel(e) {
    navigate(-1);
  }

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Add Hotel Admin</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/hoteladmin"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Hotel Admin
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Add Hotel Admin</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form onSubmit={addAdmin}>
            <div className="row mb-40">
              <div className="col-md-5">
                <label className="form-label">
                  Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="fullName"
                  value={fullName}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.fullName ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Hotel Name"
                />
                {errors.fullName && (
                  <div className="text-danger mt-2">{errors.fullName}</div>
                )}
              </div>

              <div className="col-md-5">
                <label className="form-label">
                  Email<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="email"
                  value={email}
                  onChange={handleChange}
                  placeholder="Enter Email"
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                />
                {errors.email && (
                  <div className="text-danger mt-2">{errors.email}</div>
                )}
              </div>

              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Mobile<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="mobile"
                  value={mobile}
                  onChange={handleChange}
                  placeholder="Enter Mobile Number"
                  className={`form-control ${
                    errors.mobile ? "is-invalid" : ""
                  }`}
                />
                {errors.mobile && (
                  <div className="text-danger mt-2">{errors.mobile}</div>
                )}
              </div>

              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Username<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="username"
                  onChange={handleChange}
                  value={username}
                  placeholder="Enter Username"
                  className={`form-control ${
                    errors.username ? "is-invalid" : ""
                  }`}
                />
                {errors.username && (
                  <div className="text-danger mt-2">{errors.username}</div>
                )}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                onClick={cancel}
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isDisabled}
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddHotelOwner;
